module.exports = __webpack_public_path__ + "static/6h-humble-897dc328daaa83dc7407b1b5ca9db4da.png";